'use strict';

const PdfPreviewService = require('./PdfPreviewService');
const _ = require('lodash');

class DashPdfPreviewService extends PdfPreviewService {

  constructor(AnalyticsService, Flux) {
    super();
    this.AnalyticsService = AnalyticsService;
    this.Flux = Flux;
  }

  getSite () {

    const MapStore = this.Flux.Store.get('MapStore');
    return MapStore.get('site');
  }

  // Returns the current DataCapture obtained from MapStore
  getCurrentDataCapture () {

    const MapStore = this.Flux.Store.get('MapStore');
    return MapStore.get('dataCapture');
  }

  getFormattedAnnotations () {
    const AnnotationStore = this.Flux.Store.get('AnnotationStore');
    const annotations = AnnotationStore.get('current');
    return this._formatAnnotations(annotations);
  }

  getFormattedMeasurements () {
    const MeasurementStore = this.Flux.Store.get('MeasurementStore');
    const measurements = MeasurementStore.get('current');
    return this._formatMeasurements(measurements);
  }

  getFormattedOverlays () {
    const OverlayStore = this.Flux.Store.get('OverlayStore');
    const overlays = OverlayStore.get('current');
    return this._formatOverlays(overlays);
  }

  _formatAnnotations (annotations) {

    let OverlayStore = this.Flux.Store.get('OverlayStore');
    let available = OverlayStore.get('available');
    let overlay;

    return annotations.map(function(annotation) {
      return {
        id : annotation.id,
        name : annotation.name,
        layers : annotation.annotationLayers.map(function(layer) {
          // We have to assume the Overlay has been loaded here
          if(layer.overlayId) {
            if(!layer.overlay) {
              overlay = _.find(available, 'id', layer.overlayId);
              layer.overlay = { id : overlay.layerId };
            }
          }
          return layer;
        })
      };
    });
  }

  _formatOverlays (overlays) {

    return overlays.map(function(overlay) {
      return {
        id : overlay.id,
        name : overlay.name,
        layers : [{
          id : overlay.id,
          layerId: overlay.layerId,
          _ref: 'overlay-' + overlay.id
        }]
      };
    });
  }

  _formatMeasurements (measurements) {

    return measurements.map(function(measurement) {
      let featureCollection = measurement.result || measurement.request || {
        features: [] // Case for a newly created measurement that doesn't have layers
      };
      return {
        id : measurement.id,
        name : measurement.name,
        // The request comes as a geojson FeatureCollection, each layers is
        // an individual feature. Split the, into layers

        layers: featureCollection.features.map(function(feature) {
          return {
            resource: 'measurement',
            type: 'polygon',
            data: feature
          };
        })
        // Handle both for building and displaying result
      };
    });
  }

}

DashPdfPreviewService.$inject = ['AnalyticsService', 'sbFlux'];

module.exports = DashPdfPreviewService;



// WEBPACK FOOTER //
// ./src/app/shared/pdfPreview/services/DashPdfPreviewService.js